module.exports = __webpack_public_path__ + "static/media/cmr_2.055e1e31.jpg";